// query

export const notificationsQueryKeys = {
  NOTIFICATIONS_UNREAD: 'notifications-unread',
  NOTIFICATIONS_GET_ALL: 'notifications-get-all',
  NOTIFICATIONS_GET_EMAIL_FREQUENCY: 'notifications-get-email-frequency',
  NOTIFICATIONS_AVATAR_IMAGE: 'notifications-avatar-image'
}

export const notificationsMutationKeys = {
  NOTIFICATIONS_READ_ALL: 'notifications-read-all',
  NOTIFICATIONS_READ: 'notifications-read',
  NOTIFICATIONS_UPDATE_EMAIL_FREQUENCY: 'notifications-update-email-frequency'
}
